
import Vue from 'vue';
import api from '@/api/api';
import addressSelectApi from '@/api/address/api.address'

const SETPROVINCELIST 	= 'SETPROVINCELIST';
const SETCITYLIST 		= 'SETCITYLIST';
const SETREGIONALLIST 	= 'SETREGIONALLIST';
export default {
	state: {
		provinceList: [],
		cityList: [],
		regionList: []

	},
	actions: {
		getOriginProvince({commit}){

			return new Promise(function(resolve,reject){
				addressSelectApi.getOriginProvince({},function(res){
					var res = res.body;
					commit('SETPROVINCELIST',res.data)

				})
			})
		},
		getOriginCity({commit},{provinceId}){
			return new Promise(function(resolve,reject){
				addressSelectApi.getOriginProvince({'provinceId':provinceId },function(res){
					var res = res.body;
					commit('SETCITYLIST',res.data)
				})

			})
		},
		getOriginRegional({commit},{cityId}){
			return new Promise(function(resolve,reject){
				addressSelectApi.getOriginProvince({'cityId':cityId },function(res){
					var res = res.body;
					commit('SETREGIONALLIST',res.data)
				})

			})
		},
		getOpenRegional({commit},{cityId}){
			return new Promise(function(resolve,reject){
				addressSelectApi.getOpenProvince({'cityId':cityId },function(res){
					var res = res.body;
					commit('SETREGIONALLIST',res.data)
				})

			})
		},

	},
	mutations:{
		SETPROVINCELIST( state, data){
			let provinceArr  =[];
			data.map((item,index)=>{
				if(item.id !== 900000){
					provinceArr.push({
						key: item.id,
						value: item.name
					})
				}
				
			})
			state.provinceList = provinceArr;
		},
		SETCITYLIST( state, data){
			let cityArr  =[];
			data.map((item,index)=>{
				cityArr.push({
					key: item.id,
					value: item.name
				})
			})
			state.cityList = cityArr;
		},
		SETREGIONALLIST( state, data){
			let regionArr  =[];
			data.map((item,index)=>{
				regionArr.push({
					key: item.id,
					value: item.name
				})
			})
			state.regionList = regionArr;
		},
	}

}


// WEBPACK FOOTER //
// ./src/js/store/addressSelectState.js